// src/env.ts
var envContext = {
  isNextJS: typeof globalThis !== "undefined" && !!globalThis.__NEXT_DATA__,
  isBrowser: typeof window !== "undefined",
  isServer: typeof window === "undefined",
  hasGlobalEnv: typeof globalThis !== "undefined" && !!globalThis.__ENV,
  hasProcessEnv: typeof process !== "undefined" && !!process.env
};
var env = (key) => {
  let value = "";
  if (typeof globalThis !== "undefined" && globalThis.__ENV) {
    value = globalThis.__ENV[key] || "";
    if (value) {
      return value;
    }
  }
  if (envContext.hasProcessEnv) {
    value = process.env[key] || "";
    if (value) {
      return value;
    }
  }
  if (envContext.isNextJS && envContext.isBrowser && key.startsWith("NEXT_PUBLIC_")) {
    const nextData = globalThis.__NEXT_DATA__;
    if (nextData?.runtimeConfig?.[key]) {
      value = nextData.runtimeConfig[key];
      if (value) {
        return value;
      }
    }
  }
  if (envContext.isBrowser && window.__ENV?.[key]) {
    value = window.__ENV[key];
    if (value) {
      return value;
    }
  }
  return value;
};
function isServer() {
  return envContext.isServer;
}
function isClient() {
  return envContext.isBrowser;
}
function isDevOrStaging() {
  const environment = env("NEXT_PUBLIC_ENV");
  return ["LOCAL", "DEV", "STAGING"].includes(environment);
}
function isProduction() {
  const environment = env("NEXT_PUBLIC_ENV");
  return environment === "PROD" || environment === "PRODUCTION";
}
function setupGlobalEnv(envVars) {
  if (typeof globalThis !== "undefined") {
    globalThis.__ENV = {
      // Default values
      NEXT_PUBLIC_ENV: "LOCAL",
      NEXT_PUBLIC_ENV_FRONTEND_ORIGIN: "http://localhost:3000",
      NEXT_PUBLIC_ENV_CLOUDFLARE_IMAGE_ORIGIN: "https://dev.skin-seoul.com",
      NEXT_PUBLIC_ENV_SERVER_ORIGIN: "https://dev.skin-seoul.com/api",
      // Override with provided values
      ...envVars
    };
  }
}
function getEnvDebugInfo() {
  const hasGlobalEnv = typeof globalThis !== "undefined" && !!globalThis.__ENV;
  return {
    context: envContext,
    environment: env("NEXT_PUBLIC_ENV"),
    serverOrigin: env("NEXT_PUBLIC_ENV_SERVER_ORIGIN"),
    frontendOrigin: env("NEXT_PUBLIC_ENV_FRONTEND_ORIGIN"),
    imageOrigin: env("NEXT_PUBLIC_ENV_CLOUDFLARE_IMAGE_ORIGIN"),
    nodeEnv: env("NODE_ENV"),
    stage: env("STAGE"),
    globalEnvKeys: hasGlobalEnv ? Object.keys(globalThis.__ENV || {}) : [],
    processEnvKeys: envContext.hasProcessEnv ? Object.keys(process.env).filter((k) => k.startsWith("NEXT_PUBLIC_")) : []
  };
}

export {
  envContext,
  env,
  isServer,
  isClient,
  isDevOrStaging,
  isProduction,
  setupGlobalEnv,
  getEnvDebugInfo
};
